import { AddRoutesComponent } from "./add-routes/add-routes.component";
import { ViewRoutesComponent } from "./view-routes/view-routes.component";

export const RouteRouting = [
    { path: '', redirectTo: 'view-route', pathMatch: 'full' },
    { path: 'add-route', component: AddRoutesComponent },
    { path: 'view-route', component: ViewRoutesComponent }
]

export const RouteRoutingBreadcrumb =[
    {name:'Create',path:'/add-route'},
    {name:'View',path:'/view-route'},
]